export interface ErrorCodeEntry {
  code: string;
  component: string;
  description: string;
  cause: string;
}

export const ERROR_CODES: ErrorCodeEntry[] = [
  {
    code: "PLANO-001",
    component: "PlanogramSearchModal",
    description: "Unable to load planograms",
    cause:
      "Missing retailer and/or store context for the current task. The planogram search cannot execute without both retailerId and storeId.",
  },
];
